import React from "react";

type Props = {
  data: string;
};

const Title: React.FC<Props> = ({ data }) => {
  return <div className="subject">{data}</div>;
};

export default Title;
